module.exports = __webpack_public_path__ + "static/img/21.dcc7948.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/21.jpg
// module id = Z8hn
// module chunks = 0